export function currencyMinorUnitExponent(currency, locale = "en") {
    if (!currency) {
        return null;
    }

    try {
        return new Intl.NumberFormat(locale, {style: "currency", currency}).resolvedOptions().maximumFractionDigits;
    } catch {
        return null;
    }
}

export function minorUnitsToMajor(amount, currency) {
    if (amount === null || amount === undefined || amount === "" || !currency) {
        return null;
    }

    const numericAmount = Number(amount);
    const exponent = currencyMinorUnitExponent(currency);
    if (!Number.isFinite(numericAmount) || exponent === null) {
        return null;
    }

    return numericAmount / (10 ** exponent);
}

export function formatCurrencyFromMinorUnits(amount, currency, locale = "cs-CZ") {
    const majorAmount = minorUnitsToMajor(amount, currency);
    if (majorAmount === null) {
        return "—";
    }

    const exponent = currencyMinorUnitExponent(currency, locale);
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: exponent,
        }).format(majorAmount);
    } catch {
        return "—";
    }
}
